import { TBannerVariant, TBannerSize } from "../types/banner.types";

export const bannerVariantConfig = (variant: TBannerVariant) => {
    switch (variant) {
        case "info":
            return {
                backgroundColor: "var(--fx-colors-info-50, #EFF6FF)",
                color: "#1565c0",
                borderColor: "#1976d2",
                borderLeftColor: "#1976d2",
                iconColor: "#1976d2",
            };
        case "success":
            return {
                backgroundColor: "var(--fx-surface-muted, #F1F5F9)",
                color: "#1b5e20",
                borderColor: "#2e7d32",
                borderLeftColor: "#2e7d32",
                iconColor: "#2e7d32",
            };
        case "warning":
            return {
                backgroundColor: "var(--fx-colors-warning-100, #FFEDD5)",
                color: "#bf360c",
                borderColor: "#e65100",
                borderLeftColor: "#f57c00",
                iconColor: "#e65100",
            };
        case "error":
            return {
                backgroundColor: "var(--fx-colors-danger-50, #FEF2F2)",
                color: "#b71c1c",
                borderColor: "#c62828",
                borderLeftColor: "#c62828",
                iconColor: "#c62828",
            };
        default:
            return {
                backgroundColor: "var(--fx-surface-sunken, #F8FAFC)",
                color: "var(--fx-surface-text, #0F172A)",
                borderColor: "var(--fx-surface-borderstrong, #CBD5E1)",
                borderLeftColor: "var(--fx-surface-texttertiary, #94A3B8)",
                iconColor: "#757575",
            };
    }
};

export const bannerSizeConfig = (size: TBannerSize) => {
    switch (size) {
        case "sm":
            return {
                padding: "0.5rem 0.75rem",
                fontSize: "0.8rem",
                lineHeight: 1.4,
                borderRadius: "4px",
                borderWidth: "1px",
                borderLeftWidth: "3px",
                iconSize: "1rem",
                gap: "0.4rem",
            };
        case "md":
            return {
                padding: "0.75rem 1rem",
                fontSize: "0.925rem",
                lineHeight: 1.5,
                borderRadius: "6px",
                borderWidth: "1px",
                borderLeftWidth: "4px",
                iconSize: "1.25rem",
                gap: "0.6rem",
            };
        case "lg":
            return {
                padding: "1.25rem 1.5rem",
                fontSize: "1.1rem",
                lineHeight: 1.6,
                borderRadius: "8px",
                borderWidth: "1px",
                borderLeftWidth: "5px",
                iconSize: "1.5rem",
                gap: "0.75rem",
            };
        default:
            return {
                padding: "0.75rem 1rem",
                fontSize: "0.925rem",
                lineHeight: 1.5,
                borderRadius: "6px",
                borderWidth: "1px",
                borderLeftWidth: "4px",
                iconSize: "1.25rem",
                gap: "0.6rem",
            };
    }
};